import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/public/${string | ':publicLink'}/confirmation`;

export const ROUTE: RouteDefinition = `${baseRoute}/public/:publicLink/confirmation`;

export const URL = (publicLink: string): RouteDefinition => `${baseRoute}/public/${publicLink}/confirmation`;
